import { Routes } from '@angular/router';
import { AutoLoginGuard } from './_guards/auto-login.guard';
import { AuthGuard } from './_guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/splash',
    pathMatch: 'full',
  },
  {
    path: 'splash',
    loadComponent: () =>
      import('./pages/splash/splash.page').then((m) => m.SplashPage),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./pages/tabs/tabs.routes').then((m) => m.routes),
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/auth/login/login.page').then((m) => m.LoginPage),
    canActivate: [AutoLoginGuard],
  },
  {
    path: 'select-location',
    loadComponent: () =>
      import('./pages/auth/select-location/select-location.page').then(
        (m) => m.SelectLocationPage,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'settings',
    loadComponent: () =>
      import('./pages/user/settings/settings.page').then((m) => m.SettingsPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'class-details',
    loadComponent: () =>
      import('./pages/booking/class-details/class-details.page').then(
        (m) => m.ClassDetailsPage,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'attendance',
    loadComponent: () =>
      import('./pages/booking/attendance/attendance.page').then(
        (m) => m.AttendancePage,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'resources',
    loadComponent: () =>
      import('./pages/content/resources/resources.page').then((m) => m.ResourcesPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'reservations',
    loadComponent: () =>
      import('./pages/booking/reservations/reservations.page').then(
        (m) => m.ReservationsPage,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'resource-details',
    loadComponent: () =>
      import('./pages/content/resource-details/resource-details.page').then(
        (m) => m.ResourceDetailsPage,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./pages/auth/forgot-password/forgot-password.page').then(
        (m) => m.ForgotPasswordPage,
      ),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./pages/auth/reset-password/reset-password').then(
        (m) => m.ResetPasswordPage,
      ),
  },
  {
    path: 'resource-item',
    loadComponent: () =>
      import('./pages/content/resource-item/resource-item.page').then(
        (m) => m.ResourceItemPage,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'scroll',
    loadComponent: () =>
      import('./pages/scroll/scroll.page').then((m) => m.ScrollPage),
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./pages/auth/register/register.page').then(
        (m) => m.RegisterPage,
      ),
  },
  {
    path: 'r/:code',
    loadComponent: () =>
      import('./pages/auth/redirect-to-register/redirect-to-register.page').then(
        (m) => m.RedirectToRegisterPage,
      ),
  },
  {
    path: 'activate',
    loadComponent: () =>
      import('./pages/auth/activate/activate.page').then(
        (m) => m.ActivatePage,
      ),
  },
  {
    path: 'set-password',
    loadComponent: () =>
      import('./pages/auth/register/set-password/set-password.page').then(
        (m) => m.SetPasswordPage,
      ),
  },
  {
    path: 'check-in',
    loadComponent: () =>
      import('./pages/booking/check-in/check-in.page').then((m) => m.CheckInPage),
  },
  {
    path: 'account/reset-password/:id',
    loadComponent: () =>
      import('./pages/user/account/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent,
      ),
  },
  {
    path: 'payments',
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/billing/payments/list/list.component').then(m => m.ListComponent)
      },
      {
        path: 'add',
        loadComponent: () => import('./pages/billing/payments/payment-form/payment-form.component').then(m => m.PaymentFormComponent)
      },
      {
        path: 'add-ach',
        loadComponent: () => import('./pages/billing/payments/payment-form/payment-form.component').then(m => m.PaymentFormComponent)
      },
      {
        path: 'edit/:id',
        loadComponent: () => import('./pages/billing/payments/payment-form/payment-form.component').then(m => m.PaymentFormComponent)
      },
      {
        path: 'edit-ach/:id',
        loadComponent: () => import('./pages/billing/payments/payment-form/payment-form.component').then(m => m.PaymentFormComponent)
      }
    ],
  },
  {
    path: 'alerts',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/communication/alert/list/alert.component').then(
            (m) => m.AlertsComponent,
          ),
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import('./pages/communication/alert/notifications/notification.component').then(
            (m) => m.NotificationsComponent,
          ),
      },
      {
        path: 'notifications/:title',
        loadComponent: () =>
          import('./pages/communication/alert/details/notification-details.component').then(
            (m) => m.NotificationDetailsComponent,
          ),
      },
    ],
  },
  {
    path: 'invoices-pastdue',
    loadComponent: () =>
      import('./pages/billing/invoices/past-due/list/list.pastdue.component').then(
        (m) => m.ListPastDueComponent,
      ),
  },
  {
    path: 'notifications',
    loadComponent: () =>
      import('./pages/communication/notifications/notifications.page').then(
        (m) => m.NotificationsPage,
      ),
  },
  {
    path: 'barcode',
    loadComponent: () =>
      import('./pages/booking/barcode/barcode.page').then((m) => m.BarcodePage),
  },
];
